import React from "react";

const AuxiliaryText = ({ variant, children, className = "" }) => {
  return (
    <>
      {/* o	Usage: Labelling top-rated tags or other elements within the infographic. */}
      {variant === "Infographic" && (
        <p
          className={`
          ${className} listing-badge font-inter uppercase`}
        >
          {children}
        </p>
      )}
      {/* o	Usage: Pro tags only*/}
      {variant === "Protag" && (
        <p
          className={`
          ${className} mini-flag font-inter font-bold uppercase`}
        >
          {children}
        </p>
      )}

      {(variant === "CtaChip" || variant === "ToggleChip") && (
        <span
          className={`
          ${className} cta-chip font-inter`}
        >
          {children}
        </span>
      )}

      {/* o	Usage:Navigation Text*/}
      {variant === "NavigationText" && (
        <p
          className={`
          ${className} body-standard font-inter font-bold`}
        >
          {children}
        </p>
      )}
      {/* o	Usage: Menu items, dropdown lists •	Navigation Text (Menu, Dropdowns):*/}
      {variant === "MenuDropdown" && (
        <p
          className={`
          ${className} body-standard font-inter font-normal capitalize`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Menu items, dropdown lists •	Navigation Text (Submenu Text): */}
      {variant === "SubMenuDropdown" && (
        <p
          className={`
          ${className} font-inter capitalize`}
        >
          {children}
        </p>
      )}
      {/* o	Usage: Placeholder text for labels above input fields */}
      {variant === "FieldLabel" && (
        <p
          className={`
          ${className} input-label font-inter`}
        >
          {children}
        </p>
      )}
      {variant === "Placeholder" && (
        <p
          className={`
          ${className} input-placeholder font-inter`}
        >
          {children}
        </p>
      )}

  {variant === "MetricMinor" && (
        <p
          className={`
          ${className} metric-minor font-inter`}
        >
          {children}
        </p>
      )}

      {variant === "Eyebrow" && (
        <p
          className={`
          ${className} eyebrow-tag font-inter`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Status indicators like online, busy, etc */}
      {variant === "StatusIndicator" && (
        <p
          className={`
          ${className} font-inter font-normal leading-[1.4] tracking-[0px] text-[9px] sm:text-[10px] md:text-[10px] lg:text-[11px] xl:text-[11px] 2xl:text-[12px]  `}
        >
          {children}
        </p>
      )}
    </>
  );
};

export default AuxiliaryText;
